import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  loadBalance,
  saveBalance,
  deleteBalance,
  clearAjaxCall
} from '../actions/Balance'
import { loadCourses } from '../actions/Courses'

import DualRing from './DualRing'
import Error from './Error'
import AjaxSpinner from './AjaxSpinner'

import BalanceDetails from './Balance/BalanceDetails'
import EditBalance from './Balance/EditBalance'
import DeleteBalance from './Balance/DeleteBalance'

import { paymentTypes } from '../options.json'

import { money, grant } from './Utils/Service'

const initialState = {
  showDelete: false,
  showEdit: false,
  balance: {},
  search: '',
  search_course: '',
  search_payment: ''
}

class Balance extends Component {
  constructor() {
    super()
    this.showDelete = this.showDelete.bind(this)
    this.showEdit = this.showEdit.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this.state = initialState
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.hideModal()
    }
  }
  componentWillMount() {
    if (this.props.balance.list === null) {
      this.reloadBalance()
    }
    if (this.props.courses.list === null) {
      this.props.loadCourses()
    }
  }
  showDelete(balance) {
    this.setState({ showDelete: true, balance })
  }
  showEdit(balance) {
    this.setState({ showEdit: true, balance })
  }
  newBalance(subscription) {
    this.setState({
      showEdit: true,
      balance: {
        id: null,
        number: '',
        direction: 0,
        emitter: '',
        amount: '',
        causal: '',
        emission_date: '',
        payment_mode: '',
        course_id: '',
        doc: '',
        doc_name: '',
        doc_delete: false,
        notes: '',
        checksum: ''
      }
    })
  }
  hideModal() {
    this.setState({
      showDelete: false,
      showEdit: false
    })
  }
  reloadBalance() {
    this.props.loadBalance()
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.balance.ajaxSpinner &&
      !this.props.balance.ajaxSpinner &&
      this.props.balance.ajaxStatus === null
    ) {
      this.hideModal()
    }
    if (
      prevProps.balance.ajaxSpinner &&
      !this.props.balance.ajaxSpinner &&
      this.props.balance.ajaxStatus !== null
    ) {
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    }
  }
  filterList(list) {
    if (list === null) {
      return null
    }
    return list
      .filter((item) => {
        return this.state.search_course === ''
          ? true
          : item.course_id.toString() === this.state.search_course
      })
      .filter((item) => {
        return this.state.search_payment === ''
          ? true
          : item.payment_mode.toString() === this.state.search_payment
      })
      .filter(
        (el) =>
          el.number.toString().indexOf(this.state.search.toLowerCase()) >= 0 ||
          el.causal.toLowerCase().indexOf(this.state.search.toLowerCase()) >= 0
      )
  }
  trend(filteredList) {
    if (filteredList === null) {
      return null
    }
    let grps = [
      {
        label: 'Totale',
        total: 0,
        sf: 'z'
      }
    ]
    filteredList.forEach((el) => {
      let index = grps.map((e) => e.label).indexOf(el.payment_mode)
      if (index < 0) {
        grps.push({
          label: el.payment_mode,
          total: 0,
          sf: el.payment_mode[0]
        })
        index = grps.map((e) => e.label).indexOf(el.payment_mode)
      }
      grps[index].total += el.direction === 1 ? el.amount : -el.amount
      grps[0].total += el.direction === 1 ? el.amount : -el.amount
    })
    return grps.sort((a, b) => {
      return a.sf > b.sf ? 1 : b.sf > a.sf ? -1 : 0
    })
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }
  render() {
    const { list, error, loading, ajaxSpinner, uploading } = this.props.balance
    const filteredList = this.filterList(list)
    const trend = this.trend(filteredList)
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Bilancio</div>
          <div className='ph-descr'>
            <ul className='ul-filter'>
              <li>
                <input
                  type='text'
                  placeholder='Cerca movimenti'
                  onChange={(event) =>
                    this.setState({ search: event.target.value })
                  }
                  value={this.state.search}
                />
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_course: event.target.value })
                  }
                  value={this.state.search_course}
                >
                  <option value=''>Tutti i corsi</option>
                  {this.props.courses.list !== null &&
                    this.props.courses.list.map((o, index) => {
                      return (
                        <option key={index} value={o.id}>
                          {o.name}
                        </option>
                      )
                    })}
                </select>
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_payment: event.target.value })
                  }
                  value={this.state.search_payment}
                >
                  <option value=''>Tutti i tipi di pagamento</option>
                  {paymentTypes.map((o, index) => {
                    return (
                      <option key={index} value={o.value}>
                        {o.label}
                      </option>
                    )
                  })}
                </select>
              </li>
            </ul>
          </div>
          <div className='ph-trend'>
            {trend !== null &&
              trend.map((o, index) => {
                return (
                  <ul key={index} className='trend'>
                    <li className='group'>{o.label}:</li>
                    <li className={o.total >= 0 ? 'green' : 'red'}>
                      {money(o.total)}
                    </li>
                    {/* <li className="det">
                        (
                        <span className={((trend[key].in >= 0) ? 'green' : 'red')}>{money(trend[key].in)}</span> /
                        <span className={((trend[key].out >= 0) ? 'green' : 'red')}>{money(trend[key].out)}</span>
                        )
                      </li> */}
                    {/* <li className="det">entrate:</li>
                      <li className={((trend[key].in >= 0) ? 'green' : 'red')}>{money(trend[key].in)}</li>
                      <li className="det">uscite:</li>
                      <li className={((trend[key].out >= 0) ? 'green' : 'red')}>{money(trend[key].out)}</li> */}
                  </ul>
                )
              })}
          </div>
          <ul className='ph-btn'>
            {grant() && (
              <li>
                <button onClick={() => this.newBalance()} className='lnk-tools'>
                  <i className='fas fa-money-bill-wave'></i> aggiungi
                </button>
              </li>
            )}
            <li>
              <button
                onClick={() => this.reloadBalance()}
                className='lnk-tools'
              >
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
          <div className='ph-count'>
            {filteredList !== null &&
              filteredList.length +
                (filteredList.length === 1 ? ' risultato' : ' risultati')}
            {loading && <i className='fas fa-sync fa-spin'></i>}
          </div>
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        {filteredList !== null &&
          filteredList
            .sort((a, b) => {
              return b.emission_date - a.emission_date || b.id - a.id
            })
            .map((b, index) => {
              return (
                <BalanceDetails
                  key={index}
                  balance={b}
                  showDelete={this.showDelete}
                  showEdit={this.showEdit}
                />
              )
            })}
        {this.state.showEdit && (
          <EditBalance b={this.state.balance} hideModal={this.hideModal} />
        )}
        {this.state.showDelete && (
          <DeleteBalance b={this.state.balance} hideModal={this.hideModal} />
        )}
        {(ajaxSpinner || uploading) && <AjaxSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadBalance,
  saveBalance,
  deleteBalance,
  loadCourses,
  clearAjaxCall
})(Balance)



// WEBPACK FOOTER //
// ./src/components/Balance.js